module.exports = __webpack_public_path__ + "img/MD.8d0daae6.svg";